import React from 'react';
import moment from 'moment';
import { change, Field, reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { connect } from 'react-redux';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { MENU, PRODUCTS_MENU } from 'constants/widget';
import { DropDown, SingleDatePicker } from '../../../../components';

import useStyles from './styles';
import useWindowSize from '../../../../custom-hooks/useWindowSize';

const tabProps = index => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
};

const initialValues = {
  range: {
    startDate: null,
    endDate: null
  },
  numberOfGuests: 0,
  numberOfUnits: 0
};

const Menu = ({
  isFilter,
  items,
  disabledSteps,
  isProductsMenu,
  currentIndex,
  setIndex,
  lastSubmittedFormIndex,
  isAccommodationBooking,
  isRentalBooking,
  widgetForm,
  searchOptions,
  changeWidgetFormFieldValue,
  changeSearchFormFieldValue
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const [isOpenEndDatePicker, setIsOpenEndDatePicker] = React.useState(false);
  const [endDateRender, setEndDateRender] = React.useState(null);

  const guests = searchOptions?.values?.numberOfGuests ?? 0;
  const units = searchOptions?.values?.numberOfUnits ?? 0;
  const isUnits = isRentalBooking;

  
  

  const [width] = useWindowSize();

  const handleStartDateChanges = startDate => {
    if (startDate) {
      changeSearchFormFieldValue('range', {
        startDate: startDate,
        endDate: null
      });
      setEndDateRender(startDate);
      setTimeout(() => setIsOpenEndDatePicker(true));
    }
  };

  const handleChange = (event, newIndex) => {
    if (!Number.isInteger(newIndex)) return;
    setIndex(newIndex);
  };

  const isDoneSection = index => {
    if (!widgetForm) return false;
    if (index === currentIndex && widgetForm.syncErrors) return false;
    if (index < lastSubmittedFormIndex) return true;
  };

  const search = () => {
    changeWidgetFormFieldValue('range', searchOptions.values.range);
    changeWidgetFormFieldValue(
       isUnits ? 'numberOfUnits' : 'numberOfGuests',
       isUnits ? searchOptions.values.numberOfUnits : searchOptions.values.numberOfGuests
    );
  };

  const isDisabledSearch = () => {
    return (
      !searchOptions ||
      !searchOptions?.values?.range?.startDate ||
      !searchOptions?.values?.range?.endDate
    );
  };

  const getAvailableRange = () => {
    if (!endDateRender) return null;
    return {
      startDate: moment(endDateRender).add(1, 'days'),
      endDate: null,
      daysOfWeek: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    };
  };

  return (
    <div
      className={classNames(classes.wrapper, {
        [classes.defaultMenu]: !isProductsMenu
      })}
    >
      <Tabs
        value={currentIndex}
        onChange={handleChange}
        aria-label="simple tabs example"
        classes={{
          root: classes.tabsRoot,
          indicator: classes.tabsIndicator,
          fixed: classes.tabsFixed
        }}
      >
        {items.map((item, index) => (
          <Tab
            disabled={disabledSteps && disabledSteps.includes(index)}
            key={index}
            classes={{
              root: classNames(classes.tab, {
                [classes.isDoneTab]: !isProductsMenu && isDoneSection(index)
              })
            }}
            label={
              <div className={classes.tabLabelWrapper}>
                {!isProductsMenu && (
                  <>
                    {isDoneSection(index) ? (
                      <CheckCircleIcon className={classes.doneIcon} />
                    ) : (
                      <div className={classes.tabNumber}>{index + 1}</div>
                    )}
                  </>
                )}
                <Typography
                  variant="body1"
                  className={classNames({
                    [classes.selected]: currentIndex === index
                  })}
                >
                  {item.title === 'Activities | optional' &&
                  !isAccommodationBooking
                    ? t('Accommodations | optional')
                    : t(item.title)}
                </Typography>
              </div>
            }
            {...tabProps(index)}
          />
        ))}
      </Tabs>

      {isProductsMenu && isFilter && (
        <div className={classes.search}>
          <div className={classes.searchDate}>
            <Field
              id="rangeStartDate"
              name="range.startDate"
              label="Start date"
              isInput={true}
              numberOfMonths={1}
              daySize={39}
              component={SingleDatePicker}
              inputLabelClass={classes.searchLabel}
              customInputClass={classes.searchInput}
              isWidgetSearch={true}
              placeholder={width > 700 ? 'Select date' : 'Select'}
              onChangeCallback={handleStartDateChanges}
            />
          </div>

          <div className={classes.searchDate}>
            <Field
              id="rangeEndDate"
              name="range.endDate"
              label="End date"
              isInput={true}
              numberOfMonths={1}
              daySize={39}
              component={SingleDatePicker}
              inputLabelClass={classes.searchLabel}
              customInputClass={classes.searchInput}
              isWidgetSearch={true}
              placeholder={width > 700 ? 'Select date' : 'Select'}
              isFocused={isOpenEndDatePicker}
              dateRender={endDateRender}
              availableRange={getAvailableRange()}
              closeCalendarCallback={() => setIsOpenEndDatePicker(false)}
            />
          </div>

          <div className={classes.guests}>
            <div className={classes.guestsField}>
              <div className={classes.guestsLabel}>{isUnits ? t('Units') : t('Guests')}</div>
              <DropDown
                input={{
                 value: isUnits ? units : guests,
                  onChange: e => {
                    changeSearchFormFieldValue(
                      isUnits ? 'numberOfUnits' : 'numberOfGuests',
                      e.target.value
                    );
                  }
                }}
                list={[2, 4, 6, 8, 10]}
                inputBaseClass={classes.guestsInputBase}
                meta={{}}
                selectRootClass={classes.guestsSelectRoot}
                placeholder={width > 700 ? (isUnits ? 'Select units' : 'Select guests') : 'Select'}
              />
            </div>

            <Button
              variant="outlined"
              onClick={search}
              classes={{
                root: classes.searchBtn
              }}
              disabled={isDisabledSearch()}
            >
              {width > 700 ? t('Search') : <SearchIcon />}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    searchOptions: state.form.searchOptions
  };
};

const mapDispatchToProps = dispatch => ({
  changeWidgetFormFieldValue: (field, value) => {
    dispatch(change('widgetForm', field, value));
  },
  changeSearchFormFieldValue: (field, value) => {
    dispatch(change('searchOptions', field, value));
  }
});

export default reduxForm({
  form: 'searchOptions',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  initialValues
})(connect(mapStateToProps, mapDispatchToProps)(Menu));
